module.exports = __webpack_public_path__ + "img/bug.dc79181a.svg";